export const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024; // 50 MB

export const MIN_FILE_SIZE_BYTES = 1; // reject 0-byte files

/** Only PDF files are accepted by the backend. */
export const ACCEPTED_CONTENT_TYPE = 'application/pdf';
export const ACCEPTED_FILE_EXTENSION = '.pdf';

export const AI_ASSISTANT_FILES_TAG = 'AiAssistantFiles';

/** Default page size for the paginated documents list. */
export const DEFAULT_PAGE_SIZE = 20;
/** Default sort applied to the documents list. */
export const DEFAULT_SORT = 'uploadedAt,desc';

export const LIST_TIMEOUT_MS = 30_000;

export const UPLOAD_TIMEOUT_MS = 60_000;

export const DELETE_TIMEOUT_MS = 30_000;
